<template>
    <BaseDialog
        :showDialog="showPeriodRequiredDialog"
        maxDialogWidth="450"
        headline="lang_GENERAL_SELECTION_REQUIRED_DIALOG_TITLE"
        :close="() => { showPeriodRequiredDialog = false }"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t('lang_GENERAL_CAPTION_PLEASE_SELECT_PERIOD') }}.
                    </v-col>
                </v-row>
                <!-- IDEA: Put period selector here, so the user can directly chose, without go back to Page?? -->
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '../_base/BaseDialog'
import BaseButton from '../_buttons/BaseButton'

export default {
    name: "PeriodRequiredDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            alvqa: 'period-required-dialog'
        }
    },
    computed: {
        showPeriodRequiredDialog: {
            get() { return this.$store.getters.getShowPeriodRequiredDialog },
            set(showPeriodRequiredDialog) { this.$store.commit('setShowPeriodRequiredDialog', showPeriodRequiredDialog) }
        }
    }
}
</script>